import countryNameDictionary from "@/assets/js/countryNameDictionary.js";
export const sameDomain = url => {
  if (url) {
    return url.indexOf(location.host) > -1 || url.indexOf("http") < 0 || false;
  }
  return true;
};
export const notPDF = url => {
  if (url) {
    return !url || url.indexOf("pdf") < 0;
  }
  return true;
};

export const fetchCountryName = cc => {
  // console.log("fetchCountryName << ", countryNameDictionary, " :: ", cc);
  // console.log("country name ==  ", countryNameDictionary[cc]);
  return countryNameDictionary[cc];
};
/*
  return query object from query string
*/
export const stringToQuery = _string => {
  if (!_string) {
    return "";
  }
  let query = {},
    p = new URLSearchParams(_string);
  if (p.toString()) {
    p.forEach((val, key) => {
      query[key] = val;
    });
    return query;
  } else {
    return "";
  }
};

export const toDateObj = date => {
  if (date) {
    let validDateString;
    if (typeof date === "string") {
      let split = date.split("/");
      if (split.length) {
        // HOPEFULLY DD/MM/YYYY
        validDateString = `${split[2]}-${split[1]}-${split[0]}`;
      }
      return new Date(validDateString);
    }
    return new Date(date);
  }
  return null;
};

export const toDateNoTimezone = date => {
  let _date = new Date(date);
  if (_.isDate(_date)) {
    let tz = _date.getTimezoneOffset() * 60000;
    return new Date(_date.getTime() - tz).setHours(0, 0, 0, 0);
  }
  return null;
};

export const isIE = function() {
  var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
  var msie = ua.indexOf("MSIE "); // IE 10 or older
  var trident = ua.indexOf("Trident/"); //IE 11
  // console.log("ua > ", ua);
  return msie > 0 || trident > 0;
};

export const subdomain = function() {
  //return "patient";
  //return "lab";
  var subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;    
  if(subdomain=='www'){
    subdomain='';
  }
  return subdomain; 
};

/*
  For catalog rendering mainly...
*/
export const hasDimensions = item => {
  return (
    item.diameter || item.gingival_height || item.crown_height || item.length
  );
};
export const parseDimensions = (item, localize) => {
  let dimensions = [];
  if (item.diameter) {
    dimensions.push(
      `<i class="sym">${localize("diameter_sign")}</i>${item.diameter +
        localize("mm")}`
    );
  }
  if (item.gingival_height) {
    dimensions.push(`${localize("h") + item.gingival_height + localize("mm")}`);
  }
  if (item.crown_height) {
    dimensions.push(`${localize("c") + item.crown_height + localize("mm")}`);
  }
  if (item.length) {
    dimensions.push(`${localize("l") + item.length + localize("mm")}`);
  }
  return dimensions.join(`, `);
};

export const parseToString = value => {
  if (typeof value === "object") {
    return value.join(", ");
  }
  return value;
};

/*
    FETCH 
    Fetch content from cache then server
*/
export const fetchContent = async function(
  _id,
  _key,
  vm,
  state,
  commit,
  mutation,
  api,
  apiHeaders,
  apiOptions
) {

  // active cache?
  let useCache = vm.$useCache[_key];

  // locale keys
  let ln, cc;
  ({ ln, cc } = state.locale);

  // Add locale to headers
  let storageKey = `routedata_${_key}_${_id}_${cc}${cc ? "-" : ""}${ln}`;
  let _data = storage.get(storageKey);
  let dataVersion = -1;
  let json;

  // console.log("fetch data from cache >> ", storageKey, " :::: ", _data);
  if (_data) {
    json = JSON.parse(_data);
    dataVersion = json.version;
    if (mutation) {
      commit(mutation, json);
    }
  }

  /*
  After content has loaded from cache
  If an API has been passed (i.e menu doesn't need to call server (data recieved from rawitems))
  check server to see if there's an updated
  version of the data.
  */
  if (api) {
    let headers = Object.assign({ ln, cc }, apiHeaders);
    return fetchContentFromServer(
      dataVersion,
      storageKey,
      api,
      headers,
      apiOptions,
      mutation,
      commit,
      useCache
    ).then(res => {
      return res;
    });
  }
  if (!_data && !api) {
    // i.e first time loading menu...
    return { noData: true, useCache, storageKey };
  }
};
const fetchContentFromServer = async function(
  version,
  storageKey,
  api,
  headers,
  apiOptions,
  mutation,
  commit,
  cache
) {
  let options = apiOptions
    ? Object.assign({ headers }, apiOptions)
    : { headers };
  // console.log("API >> ", api);
  // console.log("OPTIONS >> ", options);
  return fetch(api, options)
    .then(function(response) {
      // console.log("respons >> ", response);
      if (response.status !== 200) {
        throw new Error("Something Went Wrong!");
      }
      return response.json();
    })
    .then(function(json) {  
      // console.log("json.version >> ", json.version, " ?? ", version);
      if (json.version !== version){// || json.version===undefined) {
        cache && storage.set(storageKey, JSON.stringify(json));
        mutation && commit(mutation, json);
      }
      return json;
    })
    .catch(function(err) {
      mutation && commit(mutation, err);
      return err;
    });
  // console.log("data fetched >> ", result, " VERSION: ", version);
  // return result;
};

/*
    STORAGE 
    CHECK SUPPORT
*/
function storageSupport() {
  try {
    return "sessionStorage" in window && window["sessionStorage"] !== null;
  } catch (e) {
    return false;
  }
}


export const createToken = length => {
  var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
  var b = [];  
  for (var i=0; i<length; i++) {
      var j = (Math.random() * (a.length-1)).toFixed(0);
      b[i] = a[j];
  }
  return b.join("");
};



// FETCH FROM STORAGE
/*
  For now all storage will use SESSION,
  unless we choose otherwise
*/
function getFromStorage(key, storageType = sessionStorage) {
  if (storageSupport()) {
    return storageType.getItem(key);
  }
  return null;
}
// SAVE TO STORAGE
function setToStorage(key, data, storageType = sessionStorage) {
  typeof data !== "string" && (data = JSON.stringify(data));
  storageSupport() && storageType.setItem(key, data);
}

export const setToLocalStorage = function(key, data)
{
  localStorage.setItem(key, data);
}

export const splitLines = function(delayMultiplyer,splitElement,outerClass,innerClass)
{
  //split text to words wrapped by spans 
  var p = splitElement;//document.getElementsByClassName('split-text')[0];
  p.innerHTML = p.innerText.split(/\s/).map(function(word) 
  {
    let wordSpan = '';

    let hypenIndex = word.indexOf("-");
    if(hypenIndex>-1)
    {
      //fix the hypen issue, 
      //in case of hypen in word we will split to more elements
      //'<span>some-word</span>' => <span>some</span><span>-</span><span>word</span>
      var hypernWordsArr = word.split("-");
      for (var ii = 0; ii < hypernWordsArr.length; ii++) {
        wordSpan = wordSpan + '<span>' + hypernWordsArr[ii] + '</span>';
        if(ii<hypernWordsArr.length-1){
          wordSpan = wordSpan + '<span>-</span>';
        }
      }      
    }else{
      wordSpan = '<span>' + word + '</span>';
    }
    return wordSpan;
  }).join(' ');

  //////////////////

  //Check when to split rows according to span position
  var lines = [];
  var line;
  var words = p.getElementsByTagName('span');
  var lastTop;
  for (var i = 0; i < words.length; i++) {
    var word = words[i];

    let wOff = word.offsetTop;
    if (word.offsetTop != lastTop) 
    {
      lastTop = word.offsetTop;
      line = [];
      lines.push(line);
    }
    line.push(word);
  }

  //combine all rows 
  var splittedText = "";
  for (var lineIndex = 0; lineIndex < lines.length; lineIndex++) {
    var lineText = "";
    for (var wordIndex = 0; wordIndex < lines[lineIndex].length; wordIndex++) {
      lineText=lineText+lines[lineIndex][wordIndex].innerText+' ';
      //Remove spaces between hypens 
      lineText = lineText.replace(" - ", "-");
      lineText = lineText.replace("- ", "-");
      lineText = lineText.replace(" -", "-");
    }    

    let lineDelay = delayMultiplyer*lineIndex;
    console.log("delayMultiplyer="+delayMultiplyer);//[0][0].innerText);
    splittedText = splittedText +
    "<div class='"+outerClass+"' style='--index:"+lineDelay+
    "'><div class='"+innerClass+"' style='--line_index:"+
    lineDelay+"'>"+lineText+"</div></div>";
  }
  p.innerHTML = splittedText;
}



// CHECK EXPIRATION
// function checkStorageExpiration(storageType, key) {
//   let curdate = new Date(),
//     date = new Date(storageType.getItem(key + "_expiration"));
//   if (!!date && curdate > date) {
//     removeFromStorage(storageType, key);
//     return true;
//   }
//   return false;
// }
// SET EXPIRATION
// function setStorageExpiration(storageType, key, days = 10) {
//   let expiredate = new Date();
//   expiredate.setDate(expiredate.getDate() + days);
//   storageType.setItem(key + "_expiration", expiredate);
// }

// REMOVE FROM STORAGE
function removeFromStorage(key, storageType = sessionStorage) {
  storageType.removeItem(key);
  // storageType.removeItem(key + "_expiration");
}

// RESTART CACHING
// function clearCache() {
//   // removeFromStorage(localStorage, "_marketcategories");
//   // removeFromStorage(sessionStorage, "_filtersUI");
//   localStorage.clear();
//   sessionStorage.clear();
// }

export const storage = {
  support: storageSupport,
  get: getFromStorage,
  set: setToStorage,
  remove: removeFromStorage
};
